<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.notification.create')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.notification.create')}}</div>
                        <button type="submit" class="btn btn-primary float-right"
                            @click="pushNotification()">{{$t('button.send')}}</button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label> {{$t('form.notification.notificationType')}} <span
                                            class="text-danger">*</span></label>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <label>
                                                <input type="radio" v-model="notification.type" value="email">
                                                {{$t('form.notification.email')}}
                                            </label>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>
                                                <input type="radio" v-model="notification.type" value="sms">
                                                {{$t('form.notification.sms')}}
                                            </label>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>
                                                <input type="radio" v-model="notification.type" value="both">
                                                {{$t('form.notification.both')}}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.notification.to')}} <span class="text-danger">*</span></label>
                                    <v-select @input="getStudents" label="FullTitle" :options="programTypes"
                                        v-model="notification.ProgramType" :reduce="programTypes => programTypes"></v-select>
                                </div>

                                <div class="form-group" v-if="notification.type == 'email'">
                                    <label>{{$t('form.notification.subject')}}</label>
                                    <input type="text" class="form-control" v-model="notification.subject">
                                </div>

                                <div class="form-group" v-if="notification.type == 'both'">
                                    <label>{{$t('form.notification.onlyEmail')}}</label>
                                    <input type="text" class="form-control" v-model="notification.subject">
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.notification.message')}}</label>
                                    <textarea rows="10" class="form-control" v-model="notification.message"></textarea>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group" v-if="notification.ProgramType">
                                    <label>{{$t('form.notification.selectFaculty')}}</label>
                                    <v-select label="Name" :options="professors" v-model="selectedProfessors"
                                    :reduce="professors => professors.ID" multiple></v-select>
                                  
                                </div>
                               
                                <template v-if="students.length">
                                    <div class="notification-label">
                                        <label>{{$t('form.notification.selectStudents')}}</label>
                                        <input type="checkbox" id="selectAllStudents" :value="true" v-model="selectAllStudents" @click="checkStudents()">
                                    </div>
                                    <div class="form-group row">
                                        <label v-for="(student, index) in students" v-bind:key="index"
                                            class="form-check-label custom-label col-6">
                                            <input type="checkbox" v-model="student.notify" :value="student.notify"
                                                checked>
                                            {{student.name }}
                                        </label>
                                    </div>
                                </template>
                            </div>
                            <p class="p-3 m-0" v-if="noStudentFlag">{{$t('form.notification.noStudentFound')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: ["permissions"],

        data() {
            return {

                alert: false,
                alertClass: null,
                alertMessage: null,

                isLoading: false,
                fullPage: true,
                noStudentFlag: 0,

                notification: {
                    subject: '',
                    message: '',
                    type: 'email',
                    ProgramType:'',
                    ProgramID:null
                },

                programTypes:[],
                students: [],
                professors: [],
                selectedProfessors: [],
                selectAllStudents:true,
            };
        },

        mounted() {
            if (!this.permissions.createNotificationsBatch) {
                return this.$router.push('/');
            }

            this.initialData();
            this.getProfessors();
        },

        methods: {

            async initialData() {
                await axios
                    .get('/api/notifications/create-batch/initial-data')
                    .then(resp=>{
                        this.programTypes = resp.data;
                    })
                    .catch(error => console.log('error fetching initial data'));
            },
           
            checkStudents(){
                /* Select all students*/
                const selectedS = !this.selectAllStudents;
                const newstudents = [];
                
                this.students.forEach((student, index) => {
                            newstudents.push({
                                name: student.name,
                                id: student.id,
                                notify: selectedS
                            });
                });


                 this.students = newstudents;
              
            },
            pushNotification() {

                if (!this.notification.ProgramType) {
                    this.showAlert(this.$t('form.validation.selectProgram'), 'danger');
                    return;
                }

                if (!this.notification.subject && this.notification.type == 'email') {
                    this.showAlert(this.$t('form.validation.subjectField'), 'danger');
                    return;
                }

                if (!this.notification.message) {
                    this.showAlert(this.$t('form.validation.messageField'), 'danger');
                    return;
                }

                // validation for none students or faculty
                const selectedStudents = [];    
                this.students.forEach(s => s.notify ? selectedStudents.push(s.id) : null);


                // console.log(selectedStudents.length, this.selectAllStudents);
                // return; 

                if (!selectedStudents.length && !this.selectedProfessors.length) {
                    this.showAlert(this.$t('form.notification.notifiable'), 'danger');
                    return;
                }

                // making form data
                let formdata = new FormData();

                formdata.append("notification", JSON.stringify(this.notification));
                formdata.append("professors", JSON.stringify(this.selectedProfessors));
                formdata.append("students", JSON.stringify(selectedStudents));

                this.isLoading = true;

                axios
                    .post("/api/notifications/create/batch", formdata)
                    .then(response => {

                        this.isLoading = false;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'NotificationIndex'
                                });
                            }, 4000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error sending batch notifications');
                    });
            },

            getStudents() {

                if (!this.notification.ProgramType) {
                    this.students = [];
                    this.selectedProfessors = [];
                    return;
                }

                this.isLoading = true;

                axios
                    .get("/api/students/search?programType=" + this.notification.ProgramType)
                    .then(response => {
                        this.isLoading = false;
                        this.students = [];
                        response.data.forEach((student, index) => {
                            this.students.push({
                                name: `${student.StudentNumber} - ${student.FirstName} ${student.LastName}`,
                                id: student.ID,
                                notify: true
                            });
                        });
                        
                        this.noStudentFlag = this.students.length == 0 ? true : false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error fetching batch students');
                    });
            },

            getProfessors() {
                axios
                    .get("/api/professors?full")
                    .then(response => {
                        response.data.forEach(p => {
                            this.professors.push({
                                ID: p.ID,
                                Name: `${p.FirstName} ${p.LastName}`
                            });
                        })
                    })
                    .catch(error => console.log('error fetching faculty members'));
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>
